import React, { useCallback, useEffect, useState } from "react";
import { Button } from "../components/Button";
import { getRates } from "../services/ratesServices";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [rates, setRates] = useState({ amount: "", date: "", hours: "" });

  const getLastRate = useCallback(async () => {
    const rate = await getRates();
    setLoading(false);
    setRates(rate);
  }, []);

  useEffect(() => {
    getLastRate();
  }, [getLastRate]);

  return (
    <main className="bg-primary-300 min-h-screen ">
      {loading && (
        <div className="fixed bg-traslucid-black top-0 left-0 h-full w-full flex justify-center items-center">
          <svg
            className="animate-spin h-16 w-16 text-primary-200"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      )}
      <div className="max-w-xl block mx-auto">
        <section className="py-4">
          <img
            className="bg-white h-16 w-16 rounded-full block mx-auto"
            height={64}
            width={64}
            src="/assets/logo-tramvene.png"
            alt="tramvene"
            loading="lazy"
            decoding="async"
          />
        </section>
        <section className="px-6">
          <p className="font-bold text-white mb-4 text-xl sm:text-2xl leading-3">
            Tasa Actual €
          </p>
          <p className="font-title font-bold text-6xl sm:text-7xl text-center leading-none">
            {rates.amount}
          </p>
          <p className="text-white text-right text-sm sm:text-base leading-3">
            sujeta a variación
          </p>
          <div className="flex items-center mb-6">
            <img
              className="h-9 w-9 mr-4"
              height={36}
              width={36}
              src="/assets/calendar.png"
              alt="Fecha"
              loading="lazy"
              decoding="async"
            />
            <p className="font-title font-bold text-white text-lg sm:text-xl">
              {rates.date}
            </p>
          </div>
          <div className="flex items-center mb-6">
            <img
              className="h-9 w-9 mr-4"
              height={36}
              width={36}
              src="/assets/time.png"
              alt="Hora"
              loading="lazy"
              decoding="async"
            />
            <p className="font-title font-bold text-white text-lg sm:text-xl">
              {`${rates.hours} H`}
            </p>
          </div>
        </section>
        <section className="px-6">
          <div className="flex flex-col justify-center items-center">
            <Button
              className="mb-4"
              component="a"
              href="https://www.tramvene.com/servicios/envios/"
            >
              Enviar
            </Button>
            <p className="font-bold text-center text-base sm:text-lg">
              Tarjeta / Transferencia / Efectivo
            </p>
          </div>
        </section>
        <section className="py-4">
          <img
            className="w-full h-auto"
            src="/assets/money.gif"
            alt="Dinero"
            loading="lazy"
            decoding="async"
            width={500}
            height={281}
          />
        </section>
        <section className="px-6">
          <div className="flex justify-between mb-4">
            <p className="text-white font-bold text-base sm:text-lg">
              Paga comodamente con tus tarjetas
            </p>
            <img
              className="w-20 h-auto object-contain"
              src="/assets/visa.png"
              alt="Dinero"
              loading="lazy"
              decoding="async"
              width={80}
              height={48}
            />
          </div>
          <div className="flex flex-col items-center justify-center">
            <img
              className="h-4 w-auto"
              src="/assets/flags.png"
              alt="Venezuela"
              loading="lazy"
              decoding="async"
              width={94}
              height={16}
            />
            <p className="font-semibold text-center mb-2 text-sm sm:text-base">
              www.tramvene.com
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Home;
